import { render, staticRenderFns } from "./ChatbotSupportCompatibilityLevelChart.vue?vue&type=template&id=251bba33"
import script from "./ChatbotSupportCompatibilityLevelChart.vue?vue&type=script&lang=js"
export * from "./ChatbotSupportCompatibilityLevelChart.vue?vue&type=script&lang=js"
import style0 from "./ChatbotSupportCompatibilityLevelChart.vue?vue&type=style&index=0&id=251bba33&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports